<template>
  <component :is="childComponent"/>
</template>

<script>
import configFn from './config'
// 事故详情
import accidentDetail from '@/pages/carsService/accident/detail'
// 维保详情
import maintenanceDetail from '@/pages/carsService/maintenance/detail'
// 个人租赁订单详情
import personalOrderDetail from '@/pages/orders/personalOrder/detail'
// 企业租赁订单详情
import enterpriseOrderDetail from '@/pages/orders/enterpriseOrder/detail/index'
// 逾期详情
import overdueDetail from './components/overdueDetail/index.vue'

export default {
  name: 'customerChildDetail',
  props: ['tabType'],
  data() {
    const { customerChildDetailComponent = {} } = configFn.call(this)
    return {
      customerChildDetailComponent,
    }
  },
  computed: {
    childComponent() {
      return this.customerChildDetailComponent[this.tabType]
    },
  },
  components: {
    accidentDetail,
    maintenanceDetail,
    personalOrderDetail,
    enterpriseOrderDetail,
    overdueDetail,
  },
}
</script>
